import React, { useState, useContext } from "react";

const AppContext = React.createContext();

export const useAppContext = () => {
  return useContext(AppContext);
};
const ContextProviter = ({ children }) => {
  const [toggleSidebar, setToggleSidebar] = useState(false);


  const value = {
    toggleSidebar,
    setToggleSidebar,
  };


  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default ContextProviter;
